"use client";

import { Box } from "@mui/material";
import { caretDownSx } from "@/src/components/common/broadsheet/tokens";

export default function SelectCaret({ className }: { className?: string }) {
  return (
    <Box
      component="span"
      aria-hidden="true"
      className={className}
      sx={{
        ...caretDownSx(),
        position: "absolute",
        right: "0.75rem",
        top: "calc(50% - 0.15625rem)",
        pointerEvents: "none",
      }}
    />
  );
}
